module.exports = __webpack_public_path__ + "img/shape-hex-pink.b739aea0.png";